const baseApiPaths = {
  'initialize': 'campaigns',
  'search': 'campaignsearch'
}

const actionsApiPaths = {
  'export': 'campaigns/export',
  'delete': 'api/campaigns',
  'edit': 'campaigns/edit'
}

const apiPathsConfig = {
  ...baseApiPaths,
  ...actionsApiPaths
}

export default apiPathsConfig;